module.exports = __webpack_public_path__ + "img/yoga frame.7f4ad704.svg";